export const GST = {
  effectivefrom: "2022-08-17",
  effectiveTo: null,
  id: 1,
  name: "GST",
  rate: 10,
}
